/**
 * Created by ganlu on 09/10/2016.
 */
import badgeImageTpl from './badge-image.html';
import badgeTextTpl from './badge-text.html';
import badgeReproductionTextTpl from './badge-reproduction-text.html';
import badgeTextTplEn from './badge-text-en.html';
import badgeReproductionTextTplEn from './badge-reproduction-text-en.html';

class BadgeService {
    constructor($window) {
        "ngInject";
        this.$window=$window;

    }

    getBadgeContent(article) {
        let content = '';
        if (article.license.type != 'none') {
            content = content + badgeImageTpl;
        }
        if(this.$window.localStorage.yuanben_lang=='en'){
            content = content + badgeTextTplEn;
        }else{
            content = content + badgeTextTpl;
        }


        content = content.replace(/__article_url__/g, article.url);
        content = content.replace(/__badge_src__/g, 'src="' + article.badge_url + '"');
        content = content.replace(/__short_id__/g, article.short_id);
        content = content.replace(/__author_id__/g, article.user_id);
        content = content.replace(/__author_name__/g, article.author_name);

        return content;
    }

    getReproductionBadgeContent(article, reproduction) {
        var content = '';
        if (article.license.type != 'none') {
            content = content + badgeImageTpl;
        }
        if(this.$window.localStorage.yuanben_lang=='en'){
            content = content + badgeReproductionTextTplEn;
        }else{
            content = content + badgeReproductionTextTpl;
        }

        content = content.replace(/__badge_src__/g, 'src="' + reproduction.badge_url + '"');
        content = content.replace(/__article_url__/g, reproduction.url);
        content = content.replace(/__short_id__/g, reproduction.short_id);
        content = content.replace(/__author_id__/g, article.user_id);
        content = content.replace(/__author_name__/g, article.author_name);
        content = content.replace(/__reproduction_url__/g, reproduction.url);

        return content;
    }
}

export default BadgeService



// WEBPACK FOOTER //
// ./src/app/services/badge/badge.service.js